import React from "react";
import { WizardContext } from "./contextProvider";

function useWizardContext() {
  const context = React.useContext(WizardContext);

  return context;
}

export default useWizardContext;
